import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js'

export function createGLTFLoader(decoderPath = 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/') {
    const dracoLoader = new DRACOLoader()
    dracoLoader.setDecoderPath(decoderPath)

    const gltfLoader = new GLTFLoader()
    gltfLoader.setDRACOLoader(dracoLoader)
    return gltfLoader
}
